<template>
  <svg v-on="$listeners" :class="svgClass" aria-hidden="true" :style="style">
    <use :xlink:href="iconName"></use>
  </svg>
</template>
<script>
export default {
  name: 'cc-svg-icon',
  props: {
    /**
     * @description svg 名称
     */
    iconClass: {
      type: String
    },
    /**
     * @description 自定义 class 类名
     */
    className: {
      type: String
    },
    /**
     * @description svg 大小
     */
    size: {
      type: String,
      default: '16px'
    }
  },
  computed: {
    iconName () {
      return `#icon-${this.iconClass}`
    },
    svgClass () {
      if (this.className) {
        return `cc-svg-icon ${this.className}`
      }
      return `cc-svg-icon`
    },
    style () {
      return {
        width: this.size,
        height: this.size
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cc-svg-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  fill: currentColor;
  overflow: hidden;
}
</style>
